import React from "react";
import ClipLoader from "react-spinners/ClipLoader";

import CheckboxFilterGroup from "@areas/shared/components/filters/CheckboxFilterGroup";

import btnStyles from "@areas/employer/components/buttons/styles/button.module.css";
import styles from "./styles/filter.module.css";

function Filter({ load, data, set, values, setTypes, types, submit }) {
  const chooseType = (type) => {
    let has = types.filter((p) => p === type);
    if (has.length > 0) {
      setTypes((p) => p.filter((p) => p !== type));
    } else {
      setTypes((p) => [...p, type]);
    }
    set([]);
  };
  const checkDefaultOpenStyle = (values, name) => {
    return values.filter((p) => p.name === name).length > 0;
  };
  const chooseFilter = (name, value) => {
    if (values.some((p) => p.name === name && p.value === value)) {
      set((p) => p.filter((item) => item.name !== name || item.value !== value));
    } else {
      set((p) => [...p, { name, value }]);
    }
  };
  const generateFilter = (data) => {
    let result = [];
    for (let i = 0; i < data.length; i++) {
      switch (data[i].Type) {
        case "checkboxGroup":
          result[result.length] = (
            <CheckboxFilterGroup
              key={data[i].Name || i}
              styles={styles}
              name={data[i].Name}
              title={data[i].Title}
              options={data[i].Options}
              values={values}
              defaultOpen={checkDefaultOpenStyle(values, data[i].Name)}
              onChange={chooseFilter}
            />
          );
          break;
        default:
          continue;
      }
    }
    return result;
  };
  return (
    <div className={`${styles.filter}`}>
      <div className={styles.searchFor}>
        <div
          onClick={() => chooseType(2)}
          className={`${btnStyles.button} ${styles.option}${
            types && types.filter((p) => p === 2).length
              ? ` ${styles.active}`
              : ""
          }`}
        >
          ВУЗ
        </div>
        <div
          onClick={() => chooseType(3)}
          className={`${btnStyles.button} ${styles.option}${
            types && types.filter((p) => p === 3).length
              ? ` ${styles.active}`
              : ""
          }`}
        >
          СПО
        </div>
      </div>
      <div className={styles.inner}>
        {load ? (
          <div className="d-flex w-100 justify-content-center">
            <ClipLoader />
          </div>
        ) : (
          generateFilter(data)
        )}
      </div>
      {data.length > 0 && !load ? (
        <div className={styles.submit}>
          <div
            onClick={() => submit()}
            className={`${btnStyles.button} ${styles.button}`}
          >
            Применить фильтр
          </div>
        </div>
      ) : null}
      {data.length > 0 && !load ? (
        <div className={styles.clear}>
          <div
            onClick={() => {
              set([]);
              submit(undefined, true);
            }}
            className={`${btnStyles.button} ${styles.button}`}
          >
            Сбросить фильтр
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default Filter;
